// @flow
import React, { useContext } from 'react';

import { messageFormat } from '@clubmed/utils';

import ResponsiveContext from 'Components/utils/responsive/responsiveContext';

import { GoogleStreetView } from 'Components/frameworks/map/GoogleStreetView.jsx';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';

type Props = {
  config: CMSContent,
  id?: string,
  resort: Resort,
};

export function ProductGoogleStreetViewLine({
  config: {
    common: {
      close,
      maps: { productGoogleStreetView },
    },
  },
  id,
  resort: { name, streetView },
}: Props) {
  const { isTablet } = useContext(ResponsiveContext);

  const ratio = isTablet
    ? {
        w: 1280,
        h: 240,
      }
    : {
        w: 852,
        h: 340,
      };

  return (
    <SiteContainer id={id} className="Line">
      <GoogleStreetView
        {...streetView}
        closeLabel={close}
        height={ratio.h}
        title={messageFormat(productGoogleStreetView).format({
          name,
        })}
        width={ratio.w}
      />
    </SiteContainer>
  );
}
